import { render, staticRenderFns } from "./BusinessCooperation.vue?vue&type=template&id=72f29cd8&scoped=true"
import script from "./BusinessCooperation.vue?vue&type=script&lang=js"
export * from "./BusinessCooperation.vue?vue&type=script&lang=js"
import style0 from "./BusinessCooperation.vue?vue&type=style&index=0&id=72f29cd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f29cd8",
  null
  
)

export default component.exports